import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./style.scss";

import { canUseDOM } from "../../utils";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PreSalesInStoreOrderConfirmation from "../../sections/presales-in-store-order-confirmation";
import PreSalesOnlineOrderConfirmation from "../../sections/presale-online-order-confirmation";
import { selectUserState } from "../../selectors/application";
import { authProvider } from "../../services/authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import store from "../../redux/store/store";
import useQuery from "../../utils/useQuery";

const PreSalesOrderConfirmation = prop => {
  const { rendering, lang, history, page } = prop;
  const query = useQuery();
  const orderId = canUseDOM() ? query.orderId : "";
  const queryInStore = canUseDOM() ? query.inStore : "";
  const queryMembership = canUseDOM() ? query.membership : "";
  useEffect(() => {
    //** Measurements */
    window.dataLayer = window.dataLayer || [];
    let _currency = "EUR";
    let _country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "se";
    if (_country === "se") {
      _currency = "SEK";
    }
    let _page = {
      type: page.fields.pageType,
      currency: _currency,
      country: lang
    };
    window.dataLayer.push({
      event: "virtualPageview",
      virtualPageUrl: history.location.pathname + history.location.search,
      virtualPageTitle: "pre_sales_order_confirmation",
      page: _page
    });
  }, []);
  return (
    <section className="pre-sales-order-confirmation grid" datasourceid={rendering.dataSource}>
      {canUseDOM() && (
        <AzureAD provider={authProvider} reduxStore={store}>
          {({ authenticationState }) => {
            return (
              <React.Fragment>
                {authenticationState === AuthenticationState.Unauthenticated && <PreSalesOnlineOrderConfirmation {...{ ...prop, orderId, queryInStore, queryMembership }} />}
                {authenticationState === AuthenticationState.Authenticated && <PreSalesInStoreOrderConfirmation {...{ ...prop, orderId }} />}
              </React.Fragment>
            );
          }}
        </AzureAD>
      )}
    </section>
  );
};

PreSalesOrderConfirmation.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    heaingType: PropTypes.object,
    headingBody: PropTypes.object,
    body: PropTypes.shape({ value: PropTypes.string })
  })
};
const mapStateToProps = state => ({
  user: selectUserState(state)
});
export default withRouter(connect(mapStateToProps, null)(PreSalesOrderConfirmation));
